export class SAPContractOptions {
    vin: string;
    idNumber: string;
    firstName: string;
    lastName: string;
    mobileNumber: string;
    emailAddress: string;
    salesDocType: string;
    currentOdometer: number;
    startKM: number;
    endKM: number;
    years: number;
}
